import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_USE_MEMBERSHIP_DONATION_LANGUAGE = createFcmDetails('use_membership_donation_language', {
	owner: 'Payments',
	context: 'Payment forms',
	description: 'Whether or not to use copy that refers to transactions as membership',
	import: false,
});
